import { ModalButtonDirective } from './modal-button.directive';
import { Injectable, ComponentRef, QueryList } from '@angular/core';
import { ModalContainerComponent } from './modal-container.component';

@Injectable()
export class BsModalRef {
  /**
   * Reference to a component inside the modal. Null if modal's been created with TemplateRef
   */
  content?: any | null;

  /**
   * Hides the modal
   */
  close: (e?: any) => void = Function;

  dialog?: ComponentRef<ModalContainerComponent> | null;

  buttons?: QueryList<ModalButtonDirective>;
}
